module.exports = __webpack_public_path__ + "static/img/about2_1.008de020.jpg";